const TIME_ZONE = 'America/Sao_Paulo';

const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: TIME_ZONE,
});

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: TIME_ZONE,
});

const LONG_DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: TIME_ZONE,
});

const RELATIVE_FORMATTER = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

function toDate(value: Date | string | number): Date | null {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** `dd/mm/aaaa` in America/Sao_Paulo — the timezone every delivery window is quoted in. */
export function formatDate(value: Date | string | number): string {
  const date = toDate(value);
  return date ? DATE_FORMATTER.format(date) : '';
}

/** `dd/mm/aaaa hh:mm` in America/Sao_Paulo. */
export function formatDateTime(value: Date | string | number): string {
  const date = toDate(value);
  return date ? DATE_TIME_FORMATTER.format(date) : '';
}

/** `12 de março de 2025` — used in headings where the numeric form reads as noise. */
export function formatLongDate(value: Date | string | number): string {
  const date = toDate(value);
  return date ? LONG_DATE_FORMATTER.format(date) : '';
}

const DIVISIONS: readonly {
  readonly amount: number;
  readonly unit: Intl.RelativeTimeFormatUnit;
}[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

/** "há 3 dias" / "em 2 horas" — order tracking leans on this heavily. */
export function formatRelativeTime(
  value: Date | string | number,
  now: Date | number = Date.now(),
): string {
  const date = toDate(value);
  if (!date) {
    return '';
  }

  let duration = (date.getTime() - new Date(now).getTime()) / 1000;

  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return RELATIVE_FORMATTER.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }

  return LONG_DATE_FORMATTER.format(date);
}
